import { useEffect, useState } from 'react';
import api from '../services/api';

const FALLBACK_BRAND_NAME = 'Wynder Holidays';

// Module-level cache so Navbar + Sidebar (both mounted at once) share one request
// instead of each fetching independently.
let cachedBrandName: string | null = null;
let inFlight: Promise<string> | null = null;

function fetchBrandName(): Promise<string> {
  if (cachedBrandName) return Promise.resolve(cachedBrandName);
  if (!inFlight) {
    inFlight = api
      .get('/branding')
      .then((res): string => {
        const name: string = res.data?.brand_name || FALLBACK_BRAND_NAME;
        cachedBrandName = name;
        return name;
      })
      .catch((): string => FALLBACK_BRAND_NAME)
      .finally(() => {
        inFlight = null;
      });
  }
  return inFlight;
}

export function useBrandName(): string {
  const [brandName, setBrandName] = useState(cachedBrandName || FALLBACK_BRAND_NAME);

  useEffect(() => {
    let mounted = true;
    fetchBrandName().then((name) => {
      if (mounted) setBrandName(name);
    });
    return () => {
      mounted = false;
    };
  }, []);

  return brandName;
}
